import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ppnhpxhexhxewwcexwqa.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type User = {
  id: string;
  email: string;
  user_metadata?: {
    name?: string;
    role?: string;
  };
  created_at: string;
  last_sign_in_at?: string;
};

export type AuthError = {
  message: string;
};
